import { Box, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import React from 'react';

import EnhacedBox from '../Box';

interface HorizontalProgressChartProps {
  data: {
    individualPercentage: number;
    nomineesPercentage: number;
  };
  title: string;
  icon?: React.ReactNode;
  color?: string;
}

const HorizontalProgressChart: React.FC<HorizontalProgressChartProps> = ({
  data,
  title,
  icon,
  color = '#0F23DF',
}) => {
  // Preparar los datos para el gráfico
  const chartData = [
    {
      category: 'Individuales',
      value: data.individualPercentage,
    },
    {
      category: 'Por Nóminas',
      value: data.nomineesPercentage,
    },
  ];

  return (
    <EnhacedBox
      small
      padding="20px"
      props={{ style: { width: '100%', height: '100%' } }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          width: '100%',
          marginBottom: 20,
        }}
      >
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `${color}20`,
            color,
            lineHeight: 0,
            flexShrink: 0,
          }}
        >
          {icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="caption"
            sx={{
              textTransform: 'uppercase',
              letterSpacing: 1,
              color: 'text.primary',
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
        </div>
      </div>

      <Box sx={{ height: 115, width: '100%' }}>
        <BarChart
          dataset={chartData}
          yAxis={[
            {
              scaleType: 'band',
              dataKey: 'category',
              tickLabelStyle: {
                fontSize: 12,
                fontWeight: 500,
              },
            },
          ]}
          xAxis={[
            {
              scaleType: 'linear',
              tickLabelStyle: {
                fontSize: 12,
                fill: '#666',
              },
              valueFormatter: (value) => `${value}%`,
              min: 0,
              max: 100,
              tickNumber: 5,
            },
          ]}
          series={[
            {
              dataKey: 'value',
              valueFormatter: (value) => `${value}%`,
            },
          ]}
          layout="horizontal"
          height={100}
          margin={{
            left: 100,
            right: 20,
            top: 20,
            bottom: 20,
          }}
          borderRadius={6}
          sx={{
            '& .MuiChartsAxis-line': {
              stroke: '#e0e0e0',
            },
            '& .MuiChartsAxis-tick': {
              stroke: '#e0e0e0',
            },
            '& .MuiChartsAxis-label': {
              fill: '#666',
              fontSize: '0.75rem',
            },
          }}
        />
      </Box>
    </EnhacedBox>
  );
};

export default HorizontalProgressChart;
